module.exports = __webpack_public_path__ + "static/media/Press_4col-X-10in_01_Rev.01.52192736.jpg";